module.exports = __webpack_public_path__ + "img/type--2-spans--single-lang--pt.45e8c23c.jpg";